import * as React from 'react';
import { getDirectionsUrl } from '../../services/maps-api';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../school-search-app';
import { getAvailabilityColor } from '../../utility/api-utilities';
import { PAGE_MODE } from '../../interfaces';
import { getPageProperties } from '../../services/cps-school-api';
function CpsProfile(props) {
    const school = props.school;
    const appContext = useContext(AppContext);
    const rep = school._progressReport;
    const [gocpsLink, setGocpsLink] = useState(`${document.location.origin}/gocps/gocps-school-search/?id=${school.schoolID}`)

    useEffect(() => {
        getPageProperties().then(props => {
            if (props.schoolProfilePageUrl) {
                setGocpsLink('' + props.schoolProfilePageUrl + school.schoolID);
            }
        })
    }, [])

    const contacts = [
        { name: school.administratorFullName, title: school.administratorTitle },
        { name: school.secondContactFullName, title: school.secondContactTitle },
        { name: school.thirdContactFullName, title: school.thirdContactTitle },
        { name: school.fourthContactFullName, title: school.fourthContactTitle },
        { name: school.fifthContactFullName, title: school.fifthContactTitle },
        { name: school.sixthContactFullName, title: school.sixthContactTitle },
    ];

    let basics = [
        { label: 'School Type', value: 'CPS - Based' },
        { label: 'Address', value: `${school.addressStreet}, ${school.addressCity}, ${school.addressState} ${school.addressZipCode}` },
        { label: 'Phone', value: school.phone },
        { label: 'Fax', value: school.fax },
    ];

    if (appContext.mode == PAGE_MODE.GOCPS) {
        basics = basics.filter(data => data.label != 'School Type');
        basics = basics.filter(data => data.label != 'Duration');
        basics.push({ label: 'Network', value: school.network });
    }

    const basics2 = [
        { label: 'Duration', value: 'School Year' },
        { label: 'School Day', value: school.preKSchoolDay },
        { label: 'School Hours', value: school.schoolHours },
        { label: 'Earliest Drop Off Time', value: school.earliestDropOffTime },
    ]
    //const gocpsLink = `${document.location.origin}/gocps/gocps-school-search/?id=${school.schoolID}`

    const basicInfo = (info) => {
        return info.value &&
            <div key={info.label} className="info">
                <span className="label">{info.label}: </span>
                <span className="value">{info.value}</span>
            </div>
    }
    const checkButton = (program) => {
        if (program.DisplayButton == 'Yes') {
            const date = new Date(program.ApplicationDeadline);
            if (date < (new Date())) {
                return <a className="btn" target="_blank" href="https://cps.schoolmint.com">Apply Now</a>
            }
        }
        return program.ApplicationDeadline
    }

    const qualityRating = (rating: string) => {
        return <div className="qualityRatingBlock" >
            <span className={`qualityRating-label image rounded qualityRating-${rating.toLowerCase()}`}>
                <img src={`/Static-Adage/img/search/qualityRating/GoCPS_Excel_Rating_Icon_${rating}.svg`} />
            </span>
            <span className="qualityRating-title">{rating}</span>
        </div>
    }
    return <div className="cps-profile">
        <div className="main-overview profile-section container-fluid">
            <div className="row main-school-info">
                <div className="col-sm-9">
                    <div className="content">
                        <h2>{school.schoolShortName}</h2>
                        <h3>{school.schoolLongName}</h3>
                        <p dangerouslySetInnerHTML={{ __html: school.introduction }}></p>
                        {appContext.mode !== PAGE_MODE.GOCPS &&
                        <p dangerouslySetInnerHTML={{ __html: school.prekSchoolSummary }}></p>}
                    </div>
                </div>
                <div className="col-sm-3 prek-profile-buttons">
                    {appContext.mode !== PAGE_MODE.GOCPS && <a className="btn" target="_blank" href={gocpsLink} >View other grades on GoCPS</a>}
                    {school.websiteURL && <a className="btn" target="_blank" href={school.websiteURL} >View Website</a>}
                    <a className="btn" target="_blank" href={getDirectionsUrl(`${school.addressStreet}, ${school.addressCity}, ${school.addressState} ${school.addressZipCode}`)}>Directions</a>
                </div>
            </div>
            <div className="row basics">
                <div className="col-sm-6 info-block">
                    <h3>School Information</h3>
                    {basics.map(info => basicInfo(info))}
                </div>
                <div className="col-sm-6 info-block items-no-margin">
                    <h3>Duration and Hours</h3>
                    {basics2.map(info => basicInfo(info))}
                </div>
            </div>
            <div className="row basics">
                <div className="col-sm-12 info-block">
                    <h3>Faculty</h3>
                    {contacts.filter(contact => contact.name != '').map(contact => <div key={contact.title} className="info-block">
                        <div className="title">{contact.name}</div>
                        <div className="sub-title">{contact.title}</div>
                    </div>)}
                </div>

            </div>

            <div className="header">
                <h2>Program Application Requirements</h2>
            </div>
            {school.programs.length > 0 ? <></> : <p>There are no program application requirements available.</p>}

            {school._prek && school._prek.Programs && school._prek.Programs.map(program => <div key={program.programType} className="program-listing">
                <h3>{school.schoolShortName} - Pre-K</h3>
                <div className="table-scrolling-wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th>Program Name</th>
                                <th>Ages</th>
                                <th>School Day</th>
                                <th>Availability</th>
                                <th>Application Opens</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{program.ProgramName}</td>
                                <td>{program.AcceptedGrades.split(',').map(g => <div key={g}>{g}</div>)}</td>
                                <td>{program.CategoryName}</td>
                                <td><span className={`circle ${getAvailabilityColor(program.Availability)}`}></span> {program.Availability}</td>
                                <td>{checkButton(program)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>)
            }
          
            {school._prek.QualityRating &&
                <div className="row">
                    <div className="col-sm-12 prek-overview-block accreditation-block">
                        <h3>Excelerate Quality Rating 1</h3>
                        {qualityRating(school._prek.QualityRating)}
                        <div><strong>What does "Quality Rating" mean?</strong></div>
                        <p>Quality Rating indicates the quality of a site based on the Excelerate Illinois system. More information can be found at <a href="https://www.excelerateillinois.com/" target="_blank">ExcelerateIllinois.com</a>.</p>
                    </div>
                </div>
            }
            {school.classroomLanguages &&
                <div className="row">
                    <div className="col-sm-12 prek-overview-block accreditation-block">
                        <h3>Languages</h3>
                        <div>{school.classroomLanguages}</div>
                     </div>
                </div>
            }
        </div >
        <div className="sidebar-overview">
        </div>
    </div >
}

export default CpsProfile;